import { Spinner } from "../util-cmps/spinner";
import { RequiredAsterisk } from "./required-asterisk";

export interface ExistingControl {
    status: "new" | "loading" | "fetched"
    controlId: number | null
    consolidationJson?: string | null
}

interface ExistingControlProps {
    existingControl: ExistingControl
    onExistingControlOverride: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const ExistingControlSection: React.FC<ExistingControlProps> = ({ existingControl, onExistingControlOverride }) => {

    const isExistingControl = existingControl.status === 'fetched' && existingControl.controlId

    if (existingControl.status === 'new') return null

    if (existingControl.status === 'loading') return <>
        <span></span>
        <span className="span-2">
            <Spinner isSmall={true} className="justify-start" />
        </span>
    </>

    if (!isExistingControl) return <>
        <span></span>
        <span className="span-2 form-info">No existing control found — a new one will be created.</span>
    </>


    return <>
        <label>
            Existing Control
            <RequiredAsterisk />
        </label>
        <div className="existing-control span-2">
            <span>Found control ID: {existingControl.controlId}</span>
            <ul className="clean-list">
                <li>
                    <input type="radio" name="override-control" id="override-yes" onChange={onExistingControlOverride} />
                    <label htmlFor="override-yes" className="font-normal">Use existing control</label>
                </li>
                <li>
                    <input type="radio" name="override-control" id="override-no" onChange={onExistingControlOverride} />
                    <label htmlFor="override-no" className="font-normal">Create new control</label>
                </li>
            </ul>
        </div>
    </>
}
